<h2 mat-dialog-title class="dialog-title">{{ 'CONFIRM_ACTION' | translate }}</h2>
<div mat-dialog-content class="dialog-content">
  <p>{{data.message}}</p>
</div>
<div mat-dialog-actions class="dialog-actions">
  <button mat-button class="btn-cancel" (click)="onNoClick()">{{'No' | translate}}</button>
  <button mat-button class="btn-confirm2" (click)="onYesClick()">{{'Yes' | translate}}</button>
</div>
